import { setMeta, setPickerPeriod } from '../../actions/actionsMetadata';
import { getCampaigns } from '../../actions/campaigns';
import { connect } from 'react-redux';
import SideNav from './SideNav';

const mapStateToProps = (state) => {
  return {
    metadata: state.metadataReducer,
    user: state.userReducer,
    campaign: state.campaignReducer,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMeta: (
      regionSlug,
      startDate,
      endDate,
      datePickerPeriod,
      initialDate,
      campaignId,
      focus
    ) =>
      dispatch(
        setMeta(
          regionSlug,
          startDate,
          endDate,
          datePickerPeriod,
          initialDate,
          campaignId,
          focus
        )
      ),
    setPickerPeriod: (period) => dispatch(setPickerPeriod(period)),
    getCampaigns: (regionSlug) => dispatch(getCampaigns(regionSlug)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideNav);
